var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    viewBox: "204.15 -824 551.7 688.77",
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480.35-490.77q23.5 0 39.88-16.73 16.39-16.74 16.39-40.23 0-23.5-16.74-39.89Q503.15-604 479.65-604t-39.88 16.73q-16.39 16.74-16.39 40.23 0 23.5 16.74 39.89 16.73 16.38 40.23 16.38M480-177.92q109.77-93.16 176.81-193.16t67.04-174.07q0-105.77-68.5-176.7-68.5-70.92-175.35-70.92t-175.35 70.92q-68.5 70.93-68.5 176.7 0 74.07 67.04 174.07T480-177.92m0 42.69q-136.98-118.8-206.41-221.63-69.44-102.83-69.44-188.29 0-110.93 75.16-194.89Q354.46-824 479.5-824t200.69 83.96q75.66 83.96 75.66 194.89 0 85.46-68.93 187.84Q618-254.92 480-135.23m0-412.15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.085f64ec292793dc75d256d79fabb2b0.svg";
export { ForwardRef as ReactComponent };